export default "__VITE_ASSET__BfMenjsr__"